export * from './Dialog';
export { default } from './Dialog';
//# sourceMappingURL=index.js.map